import { SvgArrowBackUp } from "../../icons/v2/ArrowBackUp";
import { SvgArrowForwardUp } from "../../icons/v2/ArrowForwardkUp";
import { useResponsive } from "../../ResponsiveProvider";
import { Tooltip } from "../tooltips";
import { Button } from "./Button";
import { HoverTarget } from "./HoverTarget";
import { View } from "./View";

export function UndoRedoButtons() {
  const { isMediumWidth, isSmallWidth, isNarrowWidth, isWideWidth } = useResponsive()

  const iconHeight = isNarrowWidth ? 24 : isSmallWidth ? 20 : isMediumWidth ? 16 : isWideWidth ? 18 : 13;
  const iconWidth = isNarrowWidth ? 24 : isSmallWidth ? 20 : isMediumWidth ? 16 : isWideWidth ? 18 : 13;

  const tooltipPosition = (isNarrowWidth || isSmallWidth || isMediumWidth) ? "right" : "top-center";

  const onUndoClick = () => {
    window.__actionsForMenu.undo();
  }

  const onRedoClick = () => {
    window.__actionsForMenu.redo();
  }

  return (
    <View style={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
      <HoverTarget
        renderContent={() => (
          <Tooltip position={tooltipPosition} style={{ marginTop: -8 }}>
            Undo last action <strong>(CTRL+Z)</strong>
          </Tooltip>
        )}
      >
        <Button type="bare" onClick={onUndoClick}>
          <SvgArrowBackUp height={iconHeight} width={iconWidth} />
        </Button>
      </HoverTarget>
      <HoverTarget
        renderContent={() => (
          <Tooltip position={tooltipPosition} style={{ marginTop: -8 }}>
            Redo last action <strong>(CTRL+SHIFT+Z)</strong>
          </Tooltip>
        )}
      >
        <Button type="bare" onClick={onRedoClick}>
          <SvgArrowForwardUp height={iconHeight} width={iconWidth} />
        </Button>
      </HoverTarget>
    </View>
  );
}